import { useSelector, useDispatch } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const Sbar = () => {
  const snackbar = useSelector((state) => state.snackbar);
  const dispatch = useDispatch();

  return (
    <>
      <Snackbar
        key={snackbar.text}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => dispatch({ type: 'SNACKBAR_CLOSE' })}
      >
        <Alert
          onClose={() => dispatch({ type: 'SNACKBAR_CLOSE' })}
          variant="filled"
          severity={snackbar.type}
        >
          {snackbar.text}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Sbar;
